import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "io-mfe-ig-index-header flex" }

import { ALPHA_HEADERS } from 'components/search/index-header-helper';
import { useSearchStore } from 'stores/search-store';


export default /*#__PURE__*/_defineComponent({
  __name: 'IndexHeader',
  setup(__props) {

function letterClick(letter: string) {

  useSearchStore().focusIndexItem(letter, undefined, true);
}


return (_ctx: any,_cache: any) => {
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ALPHA_HEADERS), (header) => {
      return (_openBlock(), _createElementBlock("div", { key: header }, [
        _createVNode(_component_q_btn, {
          flat: "",
          unelevated: "",
          onClick: ($event: any) => (letterClick(header))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(header), 1)
          ]),
          _: 2
        }, 1032, ["onClick"])
      ]))
    }), 128))
  ]))
}
}

})